module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-sensorcloud@2x-628807166362e97d151eaf19a0947d3b.png";